import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { SelfcarePassService } from '@yol-digital/ms-client';
import { catchError, map, of } from 'rxjs';
import { ENVIRONMENT_URLS_CONFIG_TOKEN } from 'app-initialization';
import { LanguageService } from 'language';
import { ToastService } from 'toast';
import { TranslateService } from 'translate';

export const resetPasswordGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const refId = route.paramMap.get('refId');
  const router = inject(Router);
  const http = inject(HttpClient);
  const toastService = inject(ToastService);
  const translateService = inject(TranslateService);
  const languageService = inject(LanguageService);
  const config = inject(ENVIRONMENT_URLS_CONFIG_TOKEN);

  const { validateResetPasswordRequest } = new SelfcarePassService.Api(config.newMicroServiceEndpoint, http).public;

  return validateResetPasswordRequest(refId).pipe(
    map(() => true),
    catchError(err => {
      const error = err.error.error;
      toastService.add(translateService.getTranslation(['password', 'errors', error]), false);
      return of(router.createUrlTree([languageService.current, 'auth', 'login']));
    })
  );
};
